import { createSlice } from '@reduxjs/toolkit'

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    notifications: [],
    toggleConfirmationDialog: false,
    confirmationResolver: null,
  },
  reducers: {
    addNotification: (state, action) => {
      const { type = 'found', entryId } = action.payload
      const msg = {
        id: entryId,
        type,
        show: true,
        timeout: 2000,
        prependIcon: 'information-outline',
        iconColor: 'primary'
      }

      switch (type) {
        case 'found':
          msg.subtitle = ` has been found and loaded!`
          break
        case 'update':
          msg.subtitle = ` has been updated successfully!`
          msg.prependIcon = 'content-save-check'
          break
        case 'removed':
          msg.subtitle = ` has been removed successfully!`
          msg.prependIcon = 'delete'
          msg.iconColor = 'error'
          break
        case 'error':
          msg.subtitle = 'Something went wrong'
          break
      }

      state.notifications.push(msg)
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        notification => notification.id !== action.payload
      )
    },
    setToggleConfirmationDialog: (state, action) => {
      state.toggleConfirmationDialog = action.payload
    },
    setConfirmationResolver: (state, action) => {
      state.confirmationResolver = action.payload
    },
    resolveConfirmation: (state, action) => {
      if (state.confirmationResolver) {
        state.confirmationResolver(action.payload)
        state.toggleConfirmationDialog = false
        state.confirmationResolver = null
      }
    },
  },
})

export const {
  addNotification,
  removeNotification,
  setToggleConfirmationDialog,
  setConfirmationResolver,
  resolveConfirmation,
} = notificationsSlice.actions

// Selectors
export const selectNotifications = (state) => state.notifications.notifications
export const selectToggleConfirmationDialog = (state) => state.notifications.toggleConfirmationDialog

// Async action for confirmation dialog
export const waitForDeleteConfirmation = () => (dispatch) => {
  return new Promise((resolve) => {
    dispatch(setConfirmationResolver(resolve))
    dispatch(setToggleConfirmationDialog(true))
  })
}

export default notificationsSlice.reducer